import { PencilIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { IconButton } from "../../../../../components/ui";
import { buildReservationNavigationTargetUrl } from "../../../searchResultNavigation";

const Actions = props => {
  const { values } = props || {};
  const { id } = values?.item || values || {};

  if (typeof id == "number") {
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get("status") || "all";
    const listId = queryParams.get("listId");
    const workingListId = queryParams.get("workingListId");
    const href = buildReservationNavigationTargetUrl({
      listContext: {
        ...(listId ? { listId } : {}),
        ...(workingListId ? { workingListId } : {}),
      },
      recordId: id,
      status,
    });

    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit User">
              <IconButton variant="clean" title="Edit User">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
